document.addEventListener("DOMContentLoaded", () => {
    const inputSearchContain = document.querySelector('label[for="label-lot-form"]');
    if (inputSearchContain) {
        const inputSearch = document.querySelector('.lot-number-input');
        const resultInner = document.querySelector('.results-search_lot');
        const overlay = document.querySelector('.search-lot_overlay');
        const lotOverlay = document.querySelector('.search-lot_overlay');
        const btnCloseModal = document.querySelector('.btn-modal_close');
        const container = document.querySelector('.our-quality__section--form-lot .container');
        const btnDownloadWrapper = document.createElement('div');
        const btnDownloadAnchor = document.createElement('a');
        const inputValue = inputSearchContain.children[0];
        let interval;

        inputSearch.addEventListener('keyup', (e) => {
            clearInterval(interval);
            resultInner.innerHTML = 'Searching...';
            resultInner.classList.add('lot-visible');
            overlay.classList.add('visible-overlay'); 
            btnCloseModal.classList.add('visible-btn-close');
            container.style.position = 'relative';
            container.style.zIndex = '20';
            interval = setInterval(function () {
                if (inputSearch.value == '') {
                    resultInner.classList.remove('lot-visible');
                    overlay.classList.remove('visible-overlay');
                    container.style.position = 'static';
                    container.style.zIndex = 'auto';
                    btnCloseModal.classList.remove('visible-btn-close');
                } else {
                    const listOfLote = JSON.parse(sessionStorage.getItem('nro_lots'));
                    let indexPdf = 0;
                    const result = listOfLote.filter((product) => product.nro_lot?.find((lot, idx) => {
                        if(lot == inputSearch.value){
                            indexPdf = idx;
                        }
                        return lot == inputSearch.value
                    }))
                    if (result.length) {
                        result.forEach(src => {
                            let certUrl;
                            const pdf = JSON.parse(src.url_lot);
                            if (pdf.length > 1 ) {
                                certUrl = pdf[indexPdf][0].original_src;
                            }else{
                                certUrl = pdf[0].original_src;
                            }
                            resultInner.innerHTML = `Lot Number: <br/><strong>${inputSearch.value}</strong>`;
                            btnDownloadWrapper.insertAdjacentElement('beforeend', btnDownloadAnchor);
                            resultInner.appendChild(btnDownloadWrapper, resultInner);
                            btnDownloadWrapper.classList.add('result-action__inner');
                            btnDownloadAnchor.classList.add('btn', 'btn--lg', 'btn-download');
                            btnDownloadAnchor.setAttribute('href', `${certUrl}`);
                            btnDownloadAnchor.innerText = 'Download PDF';
                            btnDownloadAnchor.style.display = 'flex';
                            ;
                        });
                    } else {
                        resultInner.innerText = 'Sorry, this batch number does not exist or the value is incorrect';
                    }
                }
                clearInterval(interval);
            }, 1000);
            if (lotOverlay) {
                lotOverlay.addEventListener('click', (e) => {
                    e.preventDefault();
                    resultInner.classList.remove('lot-visible');
                    lotOverlay.classList.remove('visible-overlay');
                    inputValue.value = "";
                    btnCloseModal.classList.remove('visible-btn-close');
                    container.style.position = 'static';
                    container.style.zIndex = 'auto';
                    if (btnDownloadAnchor) {
                        btnDownloadAnchor.style.display = 'none';
                    }
                })
            }
            if (btnCloseModal) {
                btnCloseModal.addEventListener('click', (e) => {
                    e.preventDefault();
                    resultInner.classList.remove('lot-visible');
                    lotOverlay.classList.remove('visible-overlay');
                    inputValue.value = "";
                    btnCloseModal.classList.remove('visible-btn-close');
                    container.style.position = 'static';
                    container.style.zIndex = 'auto';
                    if (btnDownloadAnchor) {
                        btnDownloadAnchor.style.display = 'none';
                    }
                })
            }
        });
    }
});